// extracted by mini-css-extract-plugin
export default {"layout":"style-layout-DJczy","content":"style-content-3Svps","section":"style-section-31Fdn","row":"style-row-1_7Xc","item":"style-item-26_3Y"};